<template>
  <AppLayout title="Configurações">
    <div v-if="carregando" class="text-muted">Carregando...</div>

    <div v-else class="card" style="max-width: 640px;">
      <div class="card-body">
        <h2 class="section-title">Estoque</h2>
        <div class="form-check form-switch">
          <input v-model="blockOversell" @change="salvar" class="form-check-input" type="checkbox" role="switch" id="inp_block_oversell">
          <label class="form-check-label" for="inp_block_oversell">Bloquear venda quando não há estoque suficiente</label>
        </div>
        <p class="text-muted small mt-2 mb-0">
          Ligado (recomendado): o PDV recusa vender mais unidades do que o estoque atual do produto.
          Desligado: a venda é aceita mesmo sem estoque suficiente e o saldo do produto pode ficar negativo.
        </p>
        <div v-if="salvo" class="text-success small mt-2"><i class="bi bi-check-circle-fill me-1"></i>Salvo.</div>
      </div>
    </div>

    <div class="card mt-3" style="max-width: 640px;">
      <div class="card-body">
        <h2 class="section-title">Serviços + Agenda</h2>
        <div class="d-flex align-items-center gap-2">
          <span class="badge" :class="servicesEnabled ? 'text-bg-success' : 'text-bg-secondary'">
            {{ servicesEnabled ? 'Ativado' : 'Desativado' }}
          </span>
        </div>
        <p class="text-muted small mt-2 mb-0">
          Pra quem, além de vender produto, também presta serviço (conserto, instalação, consulta...).
          Libera o cadastro de serviços, orçamento (que pode virar venda) e agenda de horários.
          Nas permissões de cada operador você decide quem pode vender serviço e quem pode emitir orçamento.
          <template v-if="!servicesEnabled">Fale com o suporte do LC3 Market pra ativar esse módulo na sua loja.</template>
        </p>
      </div>
    </div>
  </AppLayout>
</template>
<script>
import { onMounted, ref } from 'vue';
import AppLayout from "@/components/AppLayout.vue";
import { configuracoes } from "@/models/configuracoes";

export default {
  name: 'SettingsView',
  components: {
    AppLayout
  },
  setup() {
    const Configuracoes = configuracoes();
    const carregando = ref(true);
    const blockOversell = ref(true);
    const servicesEnabled = ref(false);
    const salvo = ref(false);

    onMounted(async () => {
      const dados = await Configuracoes.get();
      if (dados) {
        blockOversell.value = dados.block_oversell;
        servicesEnabled.value = dados.services_enabled;
      }
      carregando.value = false;
    });

    const salvar = async () => {
      salvo.value = false;
      // services_enabled não entra aqui: só o admin do backoffice liga
      // esse módulo por cliente, o dono da loja só visualiza o status.
      if (await Configuracoes.update({ block_oversell: blockOversell.value })) {
        salvo.value = true;
        setTimeout(() => { salvo.value = false; }, 2000);
      }
    }

    return { carregando, blockOversell, servicesEnabled, salvo, salvar }
  },
}
</script>
<style scoped>
.section-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-strong);
  margin-bottom: 1rem;
}
</style>
